import { render, staticRenderFns } from "./Cents.vue?vue&type=template&id=c5786534&"
import script from "./Cents.vue?vue&type=script&lang=js&"
export * from "./Cents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports